import React, { useState, useEffect } from "react";
import "./configuracion.css";
import moment from "moment";
import { NavLink as RRNavLink } from "react-router-dom";
import { CLOSE_IMAGE } from "../Componentes/Image";
import { PublicidadModal, ImageTooltipModalPublicidad, MesasModal, AreasModal } from "./../Componentes/Modal";
import { DATATABLE_AREAS, DATATABLE_GARANTIA, DATATABLE_MESAS, DATATABLE_PUBLICIDAD } from "../Componentes/Datatables";
import { DeleteModal, GarantiaModal } from "./../Componentes/Modal";
import { MDBIcon, MDBTabs, MDBTabsItem, MDBTabsLink, MDBTabsContent, MDBTabsPane } from "mdb-react-ui-kit";
import {
  get_img_publicidad,
  put_res_restaurante,
  put_res_restaurante_sts,
  post_res_restaurante,
  put_gr_garantia,
  put_gr_garantia_sts,
  post_gr_garantia,
  get_gr_garantia,
  put_delete_img_publicidad,
  imgURLServerPublicidad,
  post_img_publicidad,
  put_res_restaurante_inactivo,
  get_mesas,
  put_areas_restaurante,
  get_areas_restaurante,
  put_areas_restaurante_sts,
  post_areas_restaurante,
  put_img_publicidad,
  put_img_yappy,
} from "../Componentes/Services";
import { Container, Row, Col, NavLink } from "reactstrap";

export const Configuracion = () => {
  const [dataAreas, setDataAreas] = useState([]);
  const [error, setError] = useState("");
  const [basicModal, setBasicModal] = useState(false);
  const [iconsActive, setIconsActive] = useState("tab1");
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const handleIconsClick = (value) => {
    if (value === iconsActive) {
      return;
    }
    setIconsActive(value);
  };

  async function fetch_areas() {
    var response = await get_areas_restaurante();
    setDataAreas(response);
  }
  return (
    <div className="cfg-admin font-s12px">
      <header className="cfg-header">
        <div className="cfg-header-info">
          <h1 className="cfg-title">Administración</h1>
          <p className="cfg-subtitle">Configuración del sistema</p>
        </div>
        <MDBTabs className="cfg-tabs">
          <MDBTabsItem>
            <MDBTabsLink onClick={() => handleIconsClick("tab1")} active={iconsActive === "tab1"}>
              <MDBIcon fas icon="shield-alt" className="me-2" /> Garantías
            </MDBTabsLink>
          </MDBTabsItem>
          <MDBTabsItem>
            <MDBTabsLink onClick={() => handleIconsClick("tab2")} active={iconsActive === "tab2"}>
              <MDBIcon fas icon="bullhorn" className="me-2" /> Publicidad
            </MDBTabsLink>
          </MDBTabsItem>
          <MDBTabsItem>
            <MDBTabsLink
              onClick={() => {
                handleIconsClick("tab3");
                fetch_areas();
              }}
              active={iconsActive === "tab3"}
            >
              <MDBIcon fas icon="utensils" className="me-2" /> Mesas Restaurante
            </MDBTabsLink>
          </MDBTabsItem>
          <MDBTabsItem>
            <MDBTabsLink onClick={() => handleIconsClick("tab4")} active={iconsActive === "tab4"}>
              <MDBIcon fas icon="utensils" className="me-2" /> Areas Restaurante
            </MDBTabsLink>
          </MDBTabsItem>
        </MDBTabs>
        <NavLink tag={RRNavLink} to="/user/home" className="cfg-close" title="Cerrar">
          <img src={CLOSE_IMAGE} alt="Cerrar" />
        </NavLink>
      </header>
      <MDBTabsContent className="cfg-content">
        <MDBTabsPane show={iconsActive === "tab1"} className="overflow-c">
          <Garantia
            setError={setError}
            error={error}
            setBasicModal={setBasicModal}
            basicModal={basicModal}
            basicModalDelete={basicModalDelete}
            setBasicModalDelete={setBasicModalDelete}
            basicModalEdit={basicModalEdit}
            setBasicModalEdit={setBasicModalEdit}
            isLoading={isLoading}
            setLoading={setLoading}
          />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab2"}>
          <Publicidad
            setError={setError}
            error={error}
            setBasicModal={setBasicModal}
            basicModal={basicModal}
            basicModalDelete={basicModalDelete}
            setBasicModalDelete={setBasicModalDelete}
            basicModalEdit={basicModalEdit}
            setBasicModalEdit={setBasicModalEdit}
            isLoading={isLoading}
            setLoading={setLoading}
          />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab3"}>
          <Restaurante
            setError={setError}
            error={error}
            setBasicModal={setBasicModal}
            basicModal={basicModal}
            basicModalDelete={basicModalDelete}
            setBasicModalDelete={setBasicModalDelete}
            basicModalEdit={basicModalEdit}
            setBasicModalEdit={setBasicModalEdit}
            isLoading={isLoading}
            setLoading={setLoading}
            dataAreas={dataAreas}
          />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab4"}>
          <Areas
            setError={setError}
            error={error}
            setBasicModal={setBasicModal}
            basicModal={basicModal}
            basicModalDelete={basicModalDelete}
            setBasicModalDelete={setBasicModalDelete}
            basicModalEdit={basicModalEdit}
            setBasicModalEdit={setBasicModalEdit}
            isLoading={isLoading}
            setLoading={setLoading}
            dataAreas={dataAreas}
            fetch_areas={fetch_areas}
          />
        </MDBTabsPane>
      </MDBTabsContent>
    </div>
  );
};

function Garantia({ setError, error, basicModal, setBasicModal, setBasicModalDelete, basicModalDelete, basicModalEdit, setBasicModalEdit, isLoading, setLoading }) {
  const [dataGarantia, setDataGarantia] = useState([]);
  const [formGarantia, setFormGarantia] = useState({
    gr_id: "",
    gr_name: "",
    gr_descripcion: "",
    gr_sts: "",
  });

  const onClickUpdateGarantia = () => {
    setLoading(true);
    var body = {
      gr_id: formGarantia.gr_id,
      gr_name: formGarantia.gr_name,
      gr_descripcion: formGarantia.gr_descripcion,
    };

    var result = put_gr_garantia(body);
    result.then((data) => {
      setError("");
      if (data === true) {
        setLoading(false);
        fetchGarantia();
      } else setError("ERROR " + data);
    });
  };

  const onClickUpdateGarantia_sts = () => {
    var body = {
      gr_id: formGarantia.gr_id,
      gr_sts: 0,
    };

    var result = put_gr_garantia_sts(body);
    result.then((data) => {
      setError("");
      if (data === true) fetchGarantia();
      else setError("ERROR " + data);
    });
  };

  const onClickSaveGarantia = () => {
    setLoading(true);
    var body = {
      gr_name: formGarantia.gr_name,
      gr_descripcion: formGarantia.gr_descripcion,
    };
    if (formGarantia.gr_descripcion.length > 0 && formGarantia.gr_name.length) {
      var result = post_gr_garantia(body);
      result.then((data) => {
        setError("");
        if (data === true) {
          setLoading(false);
          fetchGarantia();
        } else setError("ERROR " + data);
      });
    } else {
      setError("Campos importantes estan vacios");
      setLoading(false);
    }
  };

  async function fetchGarantia() {
    setLoading(true);
    var response;
    response = await get_gr_garantia();
    setDataGarantia(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false);
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormGarantia({
      ...formGarantia,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchGarantia();
  }, []);

  return (
    <Container fluid className="cfg-panel font-s12px  contenedor-tabla">
      {basicModal && <GarantiaModal props={formGarantia} isOpen={basicModal} basicModalEdit={basicModalEdit} toggle={setBasicModal} toggleSave={onClickSaveGarantia} toggleSaveEdit={onClickUpdateGarantia} onChange={onChange} error={error} loading={isLoading} setLoading={setLoading} />}
      {basicModalDelete && <DeleteModal props={formGarantia.gr_name} isOpen={basicModalDelete} toggle={setBasicModalDelete} toggleDelete={onClickUpdateGarantia_sts} text={"Eliminar este registro?"} error={error} />}
      <div className="cfg-card modal-add-inventario datatable-factura css_datatable1   tabla-auto-height">
        <DATATABLE_GARANTIA dataGarantia={dataGarantia} setBasicModalDelete={setBasicModalDelete} setFormGarantia={setFormGarantia} setBasicModal={setBasicModal} setBasicModalEdit={setBasicModalEdit} setError={setError} fetchGarantia={fetchGarantia} isLoadingG={isLoading} />
      </div>
    </Container>
  );
}

function Publicidad({ setError, error, basicModal, setBasicModal, setBasicModalDelete, basicModalEdit, basicModalDelete, setBasicModalEdit, isLoading, setLoading }) {
  const [srcImage, setSrcImage] = useState("");
  const [basicModalImageTooltip, setModalImageTooltip] = useState(false);
  const [images, setImages] = React.useState([]);
  const [dataPublicidad, setDataPublicidad] = useState([]);
  const [formPublicidad, setFormPublicidad] = useState({
    img_id: "",
    img_name: "",
    img_sts: "",
    img_dataurl: "",
    img_type: "",
  });

  async function fetchPublicidad() {
    setLoading(true);
    var response;
    response = await get_img_publicidad();
    setDataPublicidad(response);
    setLoading(false);
    setError("");
    setBasicModal(false);
    setBasicModalDelete(false);
  }

  const removeImage = () => {
    var body = {
      img_id: formPublicidad.img_id,
    };

    var result = put_delete_img_publicidad(body);
    result.then((data) => {
      setError("");
      if (data === true) {
        setFormPublicidad({
          ...formPublicidad,
          img_id: "",
          img_name: "",
          img_sts: "",
          img_dataurl: "",
          img_type: "",
        });
        fetchPublicidad();
      } else setError("ERROR " + data);
    });
  };
  const onChangeImage = (imageList) => {
    setFormPublicidad({
      ...formPublicidad,
      img_dataurl: imageList[0] === undefined ? "" : imageList[0].data_url,
      img_type: imageList[0] === undefined ? "" : imageList[0].file.type,
    });
    setImages(imageList);
    setError("");
  };
  useEffect(() => {
    fetchPublicidad();
  }, []);

  const toggleSave = () => {
    var body = {
      img_id: formPublicidad.img_id,
      img_dataurl: formPublicidad.img_dataurl,
      img_type: formPublicidad.img_type !== undefined ? formPublicidad.img_type : "none",
      img_URLServer: imgURLServerPublicidad,
      img_name: formPublicidad.img_dataurl !== undefined ? moment(new Date()).format("YYYYMMDDHHmmss") : formPublicidad.img_name,
    };
    if (formPublicidad.img_dataurl.length > 0 && formPublicidad.img_type.length > 0) {
      var result = post_img_publicidad(body);
      result.then((data) => {
        setError("");
        if (data === true) {
          setLoading(false);
          fetchPublicidad();
        } else setError("ERROR " + data);
      });
    } else {
      setError("Campos importantes estan vacios");
      setLoading(false);
    }
  };
  const set_yappy_ativo = (row) => {
    var body = {
      img_id: row.img_id,
      img_yappy: row.img_yappy === "1" ? "0" : "1",
    };
    var result = put_img_yappy(body);
    result.then((data) => {
      setError("");
      if (data === true) fetchPublicidad();
      else setError("ERROR " + data);
    });
  };
  return (
    <Container fluid className="cfg-panel font-s12px contenedor-tabla">
      {basicModalImageTooltip && <ImageTooltipModalPublicidad isOpen={basicModalImageTooltip} toggle={setModalImageTooltip} srcImage={srcImage} ImgName={srcImage} />}
      {basicModalDelete && <DeleteModal props={formPublicidad.img_id} isOpen={basicModalDelete} toggle={setBasicModalDelete} toggleDelete={removeImage} text={"Eliminar este registro?"} error={error} />}
      {basicModal && <PublicidadModal toggle={setBasicModal} isOpen={basicModal} props={formPublicidad} onChangeImage={onChangeImage} images={images} removeImage={removeImage} basicModalEdit={basicModalEdit} toggleSave={toggleSave} loading={isLoading} error={error} />}
      <div xs={12} className="cfg-card modal-add-inventario datatable-factura css_datatable1  tabla-auto-height">
        <DATATABLE_PUBLICIDAD
          set_yappy_ativo={set_yappy_ativo}
          datapublicidad={dataPublicidad}
          setFormPublicidad={setFormPublicidad}
          removeImage={removeImage}
          fetchPublicidad={fetchPublicidad}
          setBasicModal={setBasicModal}
          setError={setError}
          setImages={setImages}
          setSrcImage={setSrcImage}
          setModalImageTooltip={setModalImageTooltip}
          setBasicModalDelete={setBasicModalDelete}
        />
      </div>
    </Container>
  );
}

function Restaurante({ setError, error, basicModal, setBasicModal, setBasicModalDelete, basicModalEdit, basicModalDelete, setBasicModalEdit, isLoading, setLoading, dataAreas }) {
  const [dataRestaurante, setDataRestaurante] = useState([]);
  const [formRestaurante, setFormRestaurante] = useState({
    res_id: "",
    res_nombre: "",
    res_area: "",
    res_active: "",
    res_sts: "",
  });

  const onClickUpdateRestaurante = () => {
    var body = {
      res_id: formRestaurante.res_id,
      res_nombre: formRestaurante.res_nombre,
      res_area: formRestaurante.res_area,
    };
    var result = put_res_restaurante(body);
    result.then((data) => {
      setError("");
      if (data === true) fetchMesas();
      else setError("ERROR " + data);
    });
  };

  const set_mesa_inactiva = (row) => {
    var body = {
      res_id: row.res_id,
      res_active: row.res_active === "1" ? "" : "1",
    };
    var result = put_res_restaurante_inactivo(body);
    result.then((data) => {
      setError("");
      if (data === true) fetchMesas();
      else setError("ERROR " + data);
    });
  };
  const onClickUpdateRestaurante_sts = () => {
    var body = {
      res_id: formRestaurante.res_id,
      res_sts: 0,
    };
    var result = put_res_restaurante_sts(body);
    result.then((data) => {
      setError("");
      if (data === true) fetchMesas();
      else setError("ERROR " + data);
    });
  };

  const onClickSaveRestaurante = async () => {
    if (formRestaurante.res_nombre.length > 0) {
      const body = {
        res_nombre: formRestaurante.res_nombre,
        res_area: formRestaurante.res_area,
      };
      const data = await post_res_restaurante(body);
      setError("");
      if (data === true) {
        const response = await get_mesas();
        setDataRestaurante(response);
        setBasicModal(false);
      } else {
        setError("ERROR " + data);
      }
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchMesas() {
    setLoading(true);
    var response;
    response = await get_mesas();
    setDataRestaurante(response);
    setBasicModalDelete(false);
    setBasicModalEdit(false);
    setBasicModal(false);
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormRestaurante({
      ...formRestaurante,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchMesas();
  }, []);

  var ObjAreas = [];
  dataAreas.map((area) => {
    ObjAreas.push({
      value: area.ar_id,
      label: area.ar_desc,
      objName: "Areas",
    });
    return area;
  });

  const onChangeDropdown = (selectedOptions) => {
    setFormRestaurante({
      ...formRestaurante,
      res_area: selectedOptions.value,
    });
  };
  return (
    <Container fluid className="cfg-panel font-s12px  contenedor-tabla">
      {basicModalDelete && <DeleteModal props={formRestaurante.res_nombre} isOpen={basicModalDelete} toggle={setBasicModalDelete} toggleDelete={onClickUpdateRestaurante_sts} text={"Eliminar este registro?"} error={error} />}
      {basicModal && (
        <MesasModal
          dataDropdownAreas={ObjAreas}
          onChangeDropdown={onChangeDropdown}
          props={formRestaurante}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveRestaurante}
          toggleSaveEdit={onClickUpdateRestaurante}
          onChange={onChange}
          error={error}
          loading={isLoading}
          setLoading={setLoading}
        />
      )}
      <div className="cfg-card modal-add-inventario datatable-factura css_datatable1 tabla-auto-height">
        <DATATABLE_MESAS
          dataRestaurante={dataRestaurante}
          setBasicModalDelete={setBasicModalDelete}
          setFormRestaurante={setFormRestaurante}
          setBasicModal={setBasicModal}
          setBasicModalEdit={setBasicModalEdit}
          setError={setError}
          fetchRestaurante={get_mesas}
          isLoadingG={isLoading}
          set_mesa_inactiva={set_mesa_inactiva}
        />
      </div>
    </Container>
  );
}
function Areas({ setError, error, basicModal, setBasicModal, setBasicModalDelete, basicModalEdit, basicModalDelete, setBasicModalEdit, isLoading, setLoading, dataAreas, fetch_areas }) {
  const [formAreas, setFormAreas] = useState({
    ar_id: "",
    ar_desc: "",
    ar_sts: "",
  });

  const onClickUpdateAreas = () => {
    var body = {
      ar_id: formAreas.ar_id,
      ar_desc: formAreas.ar_desc,
    };
    var result = put_areas_restaurante(body);
    result.then((data) => {
      setError("");
      if (data === true) {
        fetch_areas();
        setBasicModal(false);
        setBasicModalDelete(false);
        setBasicModalEdit(false);
      } else setError("ERROR " + data);
    });
  };

  const onClickUpdateAreas_sts = () => {
    var body = {
      ar_id: formAreas.ar_id,
      ar_sts: 0,
    };
    var result = put_areas_restaurante_sts(body);
    result.then((data) => {
      setError("");
      if (data === true) {
        fetch_areas();
        setBasicModal(false);
        setBasicModalDelete(false);
        setBasicModalEdit(false);
      } else setError("ERROR " + data);
    });
  };

  const onClickSaveAreas = () => {
    if (formAreas.ar_desc.length > 0) {
      var body = {
        ar_desc: formAreas.ar_desc,
      };
      var result = post_areas_restaurante(body);
      result.then((data) => {
        setError("");
        if (data === true) {
          fetch_areas();
          setBasicModal(false);
          setBasicModalDelete(false);
          setBasicModalEdit(false);
        } else setError("ERROR " + data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  function onChange(event) {
    const { value, name } = event.target;
    setFormAreas({
      ...formAreas,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetch_areas();
  }, []);

  return (
    <Container fluid className="cfg-panel font-s12px  contenedor-tabla">
      {basicModalDelete && <DeleteModal props={formAreas.res_nombre} isOpen={basicModalDelete} toggle={setBasicModalDelete} toggleDelete={onClickUpdateAreas_sts} text={"Eliminar este registro?"} error={error} />}
      {basicModal && <AreasModal props={formAreas} isOpen={basicModal} basicModalEdit={basicModalEdit} toggle={setBasicModal} toggleSave={onClickSaveAreas} toggleSaveEdit={onClickUpdateAreas} onChange={onChange} error={error} loading={isLoading} setLoading={setLoading} />}
      <div className="cfg-card modal-add-inventario datatable-factura css_datatable1 tabla-auto-height">
        <DATATABLE_AREAS dataAreas={dataAreas} setBasicModalDelete={setBasicModalDelete} setFormAreas={setFormAreas} setBasicModal={setBasicModal} setBasicModalEdit={setBasicModalEdit} setError={setError} fetchAreas={get_areas_restaurante} isLoadingG={isLoading} />
      </div>
    </Container>
  );
}
